module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABQElEQVRIS+3VvUrDUBjG8f9bWhH8WFohVhDECyhdxEFEFLwHRS/BQWiD0iWDqCSCg5OzohchBREHcVEvQAfBGLBd/AAxpUeCiMaAQ3npUJrxwHl/nOc8SYQ2PdImhy7UctKdGl3ZPwJZaDmX+MYaEhZwR/3fy1/RrdQH6f24BsaUsCp9+/M4TvN73s8d2cEkhjMwGR1M1vGs7SQUrZT8CiIbKpAhJMUU7vBlNC/eOsekeAuqwIwKBrdIuog79JKs92pthHR4A2RVMCOH7FjLSci+z2MyEZRTgTDHePnFZHSvwQnCrA7CHe89Rfayz3GoHKyB2dJBJESYxrUu4mWwHydoco6gVe8KnrUZr7f9NIBpXAHjKqcxnNJvzeHInxe2FBwgZkkFgTqNTIHd3EPyE6Qk/DemU38T3ehaSKBtZfgEraBOG4s2k5sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/bszh_icon_arrow_nor.png
// module id = EPll
// module chunks = 1